<template>
	<div>
		<section :class="['cookies-section', { 'd-block': showCookiesNotify }]">
			<div class="container">
				<div class="cookies-wrapper">
					<div class="cookieText">
						為增進您的使用體驗，本網站透過使用 Cookies
						記錄您的資訊。繼續使用本網站，即表示您同意我們將 Cookie
						儲存在您的電腦或行動裝置上。
					</div>
					<div class="cookieBtn">
						<button class="btn" type="button" @click="notified">我知道了</button>
					</div>
				</div>
			</div>
		</section>
		<footer class="footer-section">
			<div class="container">
				<div class="primary">
					<!--<dl>
						<dt>關於歐萊德</dt>
						<dd><a href="https://www.oright.inc/tw/about/2" target="_blank">綠色理念</a></dd>
						<dd><a href="https://www.oright.inc/tw/about/3" target="_blank">零碳永續</a></dd>
						<dd><a href="https://www.oright.inc/tw/about/4" target="_blank">純淨商品</a></dd>
						<dd><a href="https://www.oright.inc/tw/about/5" target="_blank">綠色公益</a></dd>
						<dd><a href="https://www.oright.inc/tw/about/6" target="_blank">綠色榮耀</a></dd>
						<dd><a href="https://www.oright.inc/tw/about/7" target="_blank">綠色認證</a></dd>
						<dd><a href="https://www.oright.inc/tw/about/8" target="_blank">綠色工廠</a></dd>
						<dd><a href="https://www.oright.inc/tw/about/9" target="_blank">綠建築</a></dd>
					</dl>-->
					<!--<dl>
						<dt>綠色研發</dt>
						<dd><a href="https://www.oright.inc/tw/research/2" target="_blank">國際TAF實驗室</a></dd>
						<dd><a href="https://www.oright.inc/tw/research/3" target="_blank">綠色原料</a></dd>
						<dd><a href="https://www.oright.inc/tw/research/4" target="_blank">研發理念</a></dd>
						<dd><a href="https://www.oright.inc/tw/research/5" target="_blank">綠色保養</a></dd>
					</dl>-->
					<dl v-for="categories in $store.state.headerStore.categoriesArray">
						<dt>{{ categories.name }}</dt>
						<dd v-for="category in categories.children">
							<router-link :to="`/category/${category.father_id}#category_list_${category.id}`">
								{{ category.name }}
							</router-link>
						</dd>
					</dl>
					<dl>
						<dt>更多訊息</dt>
						<dd><router-link to="/faq">購物說明</router-link></dd>
						<dd><router-link to="/page/information">購物須知</router-link></dd>
						<dd><router-link to="/page/membership_new">會員制度</router-link></dd>
						<dd><router-link to="/page/privacy">隱私權政策</router-link></dd>
						<dd><router-link to="/page/webuse">網站使用條款</router-link></dd>
						<dd><router-link to="/contact">聯絡我們</router-link></dd>
					</dl>
					<!-- <dl>
						<dt>社群媒體</dt>
						<dd><a href="https://www.facebook.com/orightonlineshopping" target="_blank">O&apos;right shop 粉絲團</a></dd>
						<dd><a href="https://page.line.me/yhz1055p?openQrModal=true" target="_blank">O&apos;right Line 官方</a></dd>
						<dd><a href="https://www.instagram.com/oright_tw_official/" target="_blank">O&apos;right IG 官方</a></dd>
					</dl> -->
				</div>
				<div class="note">
					<div class="media">
						<a href="https://www.facebook.com/GreenHeadquarters" target="_blank"><FacebookLogo /></a>
						<a href="https://page.line.me/yhz1055p?openQrModal=true" target="_blank"><LineLogo /></a>
						<a href="https://www.instagram.com/oright_tw_official/" target="_blank"><InstagramLogo /></a>
					</div>
					<div class="copyright">Copyright © {{ new Date().getFullYear() }} O'right Inc. All rights reserved.</div>
				</div>
			</div>
		</footer>
	</div>
</template>
<script>
import { getCurrentInstance, ref, onServerPrefetch } from "vue";
import { useStore } from "vuex";
import FacebookLogo from "@/assets/images/common/facebook-circle.svg";
import LineLogo from "@/assets/images/common/line-circle.svg";
import InstagramLogo from "@/assets/images/common/instagram-circle.svg";
export default {
	components: {
		FacebookLogo,
		LineLogo,
		InstagramLogo,
	},
	setup(props) {
		const store = useStore();
		const globalProperties = getCurrentInstance().appContext.config.globalProperties;
		const storage = globalProperties.$storage;
		const showCookiesNotify = ref(!globalProperties.isServer && !storage.hasKey("cookieNotify") || !globalProperties.isServer && storage.isExpire("cookieNotify") ? true : false);
		const notified = () => {
			showCookiesNotify.value = false;
			storage.setStorageSync("cookieNotify", null, 60 * 60 * 24 * 7);
		}
		if (!store.state.headerStore.categoriesArray.length) {
			(async () => {
				await store.dispatch("headerStore/getCategories", globalProperties.axios);
			})();
		}
		onServerPrefetch(async () => {
			await store.dispatch("headerStore/getCategories", globalProperties.axios);
		});
		return {
			showCookiesNotify,
			notified,
		}
	}
}
</script>
<style lang="scss">
.cookies-section {
	display: none;
	padding: 1rem 0;
	background-color: $color-black-10;
	.cookies-wrapper {
		padding: 0 1rem;
		@media all and (min-width: 768px) {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			justify-content: space-between;
		}
		.cookieText {
			font-size: 0.8rem;
			padding-bottom: 0.5rem;
			@media all and (min-width: 768px) {
				flex: 1 1 75%;
				padding-bottom: 0;
			}
		}
		.cookieBtn {
			text-align: right;
			@media all and (min-width: 768px) {
				flex: 1 1 auto;
			}
			.btn {
				font-size: 0.9rem;
				color: $brand-gray;
				border: 1px solid $brand-gray;
				&:hover {
					background-color: $brand-gray;
					color: #ffffff;
				}
			}
		}
	}
}
// 頁尾
.footer-section {
	background-color: $brand-gray;
	color: #ffffff;
	padding-top: 2rem;
	.primary {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 1rem;
		dl {
			flex: 0 0 50%;
			padding: 0 0.5rem 0.5rem 1rem;
			@media all and (min-width: 640px) {
				flex: 0 0 33%;
			}
			@media all and (min-width: 768px) {
				flex: 0 0 25%;
			}
			@media all and (min-width: 992px) {
				flex: 0 0 16.6%;
			}
			@media all and (min-width: 1200px) {
				flex: 1 0 auto;
			}
		}
		dt {
			font-size: 0.95rem;
			font-weight: $family-medium;
			margin-bottom: 0.4rem;
		}
		dd {
			a {
				font-size: 0.85rem;
				color: $color-black-30;
				display: block;
				text-decoration: none;
				&:hover {
					color: $brand-green;
				}
			}
		}
	}
	.note {
		padding: 0.5rem 0;
		border-top: 1px solid #818181;
		@media all and (min-width: 768px) {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: center;
		}
		.copyright {
			font-size: 0.8rem;
			color: $color-black-50;
		}
		// .call {
		// 	color: $color-black-30;
		// 	font-size: 0.8rem;
		// 	padding-bottom: 0.4rem;
		// 	@media all and (min-width: 768px) {
		// 		padding-bottom: 0;
		// 	}
		// 	span {
		// 		display: block;
		// 		padding-right: 1.5rem;
		// 		@media all and (min-width: 768px) {
		// 			display: inline-block;
		// 		}
		// 		&:last-child {
		// 			padding-right: 0;
		// 		}
		// 	}
		// }
		.media {
			display: flex;
			padding: 0.5rem 0;
			@media all and (min-width: 992px) {
				padding: 0;
			}
			a {
				text-decoration: none;
				padding: 0 4px;
				width: 38px;
				svg {
					width: 100%;
					height: auto;
					fill: $color-black-30;
					transition: all 0.2s ease-in;
				}
				&:hover svg {
					fill: $brand-green;
				}
			}
		}
	}
}
</style>